// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsights_container__1r2iY"};